import { render, staticRenderFns } from "./Rastreabilidade.vue?vue&type=template&id=a50fe136&scoped=true&"
import script from "./Rastreabilidade.vue?vue&type=script&lang=js&"
export * from "./Rastreabilidade.vue?vue&type=script&lang=js&"
import style0 from "./Rastreabilidade.vue?vue&type=style&index=0&id=a50fe136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50fe136",
  null
  
)

export default component.exports